'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $is_ju_Collection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.aU)));
}
export { $is_ju_Collection as $is_ju_Collection };
function $isArrayOf_ju_Collection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aU)));
}
export { $isArrayOf_ju_Collection as $isArrayOf_ju_Collection };
